//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            mesLogo0:require("../../../assets/detail/zzq_review_nor.png"),
            txt1:"报名",
            num:'1',
            isShow:false,
        }
    },

     methods: {
        changeState(index){
            this.num=0;
            this.txt1 = "已满员";
            this.isShow=true;
        },
         closeWin(){
             this.isShow=false;
         }
    }
}



// WEBPACK FOOTER //
// ./src/views/sns/activity/detail.vue